<template>
  <div :class="classes()" tabindex="0">
    <ul :class="`${el}__primaryList`">
      <li
        v-for="(navItem, i) in navItems"
        :key="`primaryListItem-${i}`"
        :class="{
          [`${el}__primaryListItem`]: true,
          [`${el}__primaryListItem--active`]:
            navItem.active || hasActiveSubitem(navItem.subNavItem),
        }"
        @mouseenter="mouseEnter(i)"
        @mouseleave="mouseLeave"
      >
        <Link
          :class="`${el}__listItemLink ${el}__listItemLink--primary ${el}__primaryListItemLink `"
          :to="navItem.to"
          :size="$matchMedia.l ? 'm' : 'l'"
        >
          <div v-if="navItem.iconName" :class="`${el}__listItemLinkIcon`">
            <Icon :name="navItem.iconName" size="xl" color="primaryBlue" />
          </div>
          <span
            v-if="isOpen || !$matchMedia.l"
            :class="`${el}__listItemLinkPrimaryText`"
            tabindex="0"
            @keyup.space="$router.push(navItem.to)"
          >
            {{ navItem.text }}
          </span>
        </Link>

        <div
          :class="{
            [`${el}__secondaryListWrapper`]: true,
            [`${el}__popover`]: !subnavIsPopover,
            [`${el}__popover--active`]: !subnavIsPopover && i === activePopover,
          }"
        >
          <div :class="!subnavIsPopover && `${el}__popoverInner`">
            <div v-if="!subnavIsPopover" :class="`${el}__popoverHeadline`">{{ navItem.text }}</div>
            <ul v-if="navItem.subNavItem" :class="`${el}__secondaryList`">
              <SecondaryNavItem
                v-for="(subNavItem, k) in navItem.subNavItem"
                :key="`secondaryListItem-${k}`"
                :subNavItem="subNavItem"
                :el="el"
                tabindex="0"
                @keyup.enter.native="$router.push(subNavItem.to)"
                @keyup.space.native="$router.push(subNavItem.to)"
              />
            </ul>
          </div>
        </div>
      </li>
      <li v-if="testing">
        <TestCareLevels />
      </li>
    </ul>
    <div v-if="$matchMedia.xl" :class="`${el}__toggleBtn`" @click="$emit('toggleNav')">
      <Icon
        size="l"
        name="arrow-left-circle-line"
        color="primaryBlue"
        :class="`${el}__toggleBtnIcon`"
      />
      <div :class="`${el}__toggleBtnText`">{{ $t('dashboard.closeNavigation') }}</div>
    </div>
  </div>
</template>

<script>
import Link from '@/objects/Link';
import Icon from '@/objects/Icon';
import SecondaryNavItem from './subcomponents/SecondaryNavItem';

export default {
  name: 'MainNav',
  props: {
    navItems: Array,
    isOpen: Boolean,
  },
  components: {
    Link,
    Icon,
    TestCareLevels: () => import('@/components/TestCareLevels'),
    SecondaryNavItem,
  },
  data() {
    return {
      testing: !!process.env.VUE_APP_TESTING,
      activePopover: null,
      el: 'c-mainNav',
      timeout: null,
      subnavIsPopover: this.isOpen,
      classes: () => {
        const el = this.el;
        return {
          [el]: true,
          [`${el}--open`]: this.isOpen,
        };
      },
    };
  },
  watch: {
    isOpen: function () {
      clearTimeout(this.timeout);
      if (this.isOpen) {
        this.subnavIsPopover = this.isOpen;
      } else {
        this.timeout = setTimeout(() => {
          this.subnavIsPopover = this.isOpen;
        }, 800);
      }
    },
  },
  methods: {
    hasActiveSubitem(items) {
      const match = items?.filter((item) => {
        if (item.active) {
          return true;
        }

        const m = item.subNavItem?.filter((sni) => sni.active);
        return m?.length === 1;
      });
      return match?.length === 1;
    },
    mouseEnter(item) {
      this.activePopover = item;
    },
    mouseLeave() {
      this.activePopover = null;
    },
  },
};
</script>
